<template>
<div class="myinfo_wrap">
    <div class="page_title_center">
        내 게시글
    </div>   
    <div class="top_round_deco"></div>
    <div>
        <post-search :user_id='user.id' />     
    </div>
</div>
</template>
<script>
import { auth } from '@/components/mixins/auth.js'
import PostSearch from '@/mobile/pages/post/PostSearch' 
export default {  
    mixins:[
        auth   
    ],   
    components:{
        PostSearch
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/mobile';
</style>